import { configureStore } from '@reduxjs/toolkit';
import googleDriveReducer from '../features/googleDrive/googleDriveSlice';

export const store = configureStore({
  reducer: {
    googleDrive: googleDriveReducer,
  },
});